const eventsHu = {
    "events_title": "Események",
    "add_event": "Esemény hozzáadása",
    "event_id": "Esemény azonosítója",
    "event_name": "Esemény megnevezése",
    "event_description": "Esemény leírása",
    "event_start_date": "Esemény kezdete",
    "event_end_date": "Esemény vége",
    "event_reservations": "Foglalások",
    "event_reservations_limit": "Foglalható helyek (fő)",
    "reservations_guest_count": "Foglalás (fő)",
    "event_delete": "Esemény törlése",
    "event_delete_confirmation": "Biztosan törölni szeretné az eseményt?",
    "events": "Események",
    "reservation_limit": "Foglalható helyek",
    "event_id_placeholder": "Pl. borkostolo-2025",
    "event_name_placeholder": "Pl. Borkóstoló 2025",
    "event_description_placeholder": "Az esemény rövid leírása",
    "event_reservations_limit_placeholder": "Pl. 10",
    "delete_event": "Esemény törlése",
    "event_created": "Esemény sikeresen létrehozva",
    "event_deleted": "Esemény sikeresen törölve",
    "event_url": "Külső URL",
    "event_url_placeholder": "pl.: https://tixa.hu/esemenyem",
    "url_description": "Az URL megadása esetén az eseményre kattintva a vendéget az URL-re irányítjuk. A rendszerben nem tud foglalást leadni az eseményre.",
    "event_start_time": "Esemény kezdete",
    "event_end_time": "Esemény vége",
    "edit_event": "Esemény szerkesztése",
    "save_event": "Esemény mentése",
    "event_updated": "Esemény sikeresen frissítve",
    "event_selector_tabs": {
        "future": "Jövőbeli események",
        "past": "Múltbeli események",
    },
    "event_selector_title": "Esemény kiválasztása",
    "no_event_available": "Nincs elérhető esemény",
    "event_image": "Esemény háttérkép",
    "delete_image": "Kép törlése",
    "image_delete_confirm": "Biztosan törölni szeretné az esemény képét a tárhelyről?",
    "image_deleted": "Kép sikeresen törölve",
    "private_event": "Privát esemény",
    "private_event_description": "A privát események nem jelennek meg a publikus listán. Csak közvetlen linkkel vagy csoport linkkel érhetők el.",
    "event_group_id": "Csoport azonosító",
    "event_group_id_placeholder": "pl. corinthia-hotel-vendegek",
    "event_group_id_description": "Ha meg van adva, az esemény a csoport oldalon jelenik meg: reservours.com/hu/events/{csoport_id}. Üresen hagyva az esemény csak közvetlen linkkel érhető el.",
    "event_group_link": "Csoport link",
    "booking_closed": "Foglalás lezárva",
    "booking_closed_description": "Ha be van pipálva, az esemény sehol sem jelenik meg és nem lehet rá foglalást leadni.",
    "generate_group_id": "Generál",
    "reset_event_id": "Visszaállítás auto-generáltra",
    "copy_event": "Esemény másolása",
    "event_name_en": "Esemény neve angolul",
    "event_name_en_placeholder": "Pl. Summer Party 2025",
    "event_description_en": "Esemény leírása angolul",
}

export default eventsHu;